import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import CampusStaff from '../pages/campus/staff';
import CampusStaffCreate from '../pages/campus/staff/create';
import CampusStaffEdit from '../pages/campus/staff/edit';
import CampusClassroom from '../pages/campus/classroom';
import CampusClassroomCreate from '../pages/campus/classroom/create';
import CampusClassroomEdit from '../pages/campus/classroom/edit';
import CampusShuttle from '../pages/campus/shuttle';
import CampusSetting from '../pages/campus/setting';
import CampusPgSetting from '../pages/campus/pg-setting';
import CampusVanSetting from '../pages/campus/van-setting';

const CampusRouter: FC = () => {
  return (
    <Switch>
      <Route path='/campus/staff' exact component={CampusStaff} />
      <Route path='/campus/staff/create' exact component={CampusStaffCreate} />
      <Route path='/campus/staff/:id/edit' exact component={CampusStaffEdit} />
      <Route path='/campus/classroom' exact component={CampusClassroom} />
      <Route path='/campus/classroom/create' exact component={CampusClassroomCreate} />
      <Route path='/campus/classroom/:id/edit' exact component={CampusClassroomEdit} />
      <Route path='/campus/shuttle' exact component={CampusShuttle} />
      <Route path='/campus/setting' exact component={CampusSetting} />
      <Route path='/campus/pg-setting' exact component={CampusPgSetting} />
      <Route path='/campus/van-setting' exact component={CampusVanSetting} />
    </Switch>
  )
}

export default CampusRouter;
